import { ref, watch, type Ref } from 'vue'
import { sleep } from '../time'

export const delayedRef = <T = any>(val: Ref<T>, delay: number): Ref<T> => {
  const delayed = ref<T>(val.value)
  watch(val, async () => {
    await sleep(delay)
    ;(delayed as any).value = val.value
  })
  return delayed as Ref<T>
}
